/**
 * Sidebar — Navegación principal de la aplicación.
 */

import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Calendar,
  Wallet,
  Timer,
  Sparkles,
  ChevronLeft,
  ChevronRight,
  Package,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAppStore } from '@/stores/appStore';
import { Button } from '@/components/ui/button';

const navItems = [
  {
    section: 'Personal',
    items: [
      { to: '/personal', icon: LayoutDashboard, label: 'Dashboard' },
      { to: '/personal/paquetes', icon: Package, label: 'Paquetes y Precios' },
      { to: '/personal/calendario', icon: Calendar, label: 'Calendario' },
      { to: '/personal/finanzas', icon: Wallet, label: 'Finanzas' },
      { to: '/personal/tiempo', icon: Timer, label: 'Tiempo' },
    ],
  },
  {
    section: 'Clientes',
    items: [
      { to: '/clientes', icon: Users, label: 'Mis Clientes' },
    ],
  },
  {
    section: 'Herramientas',
    items: [
      { to: '/ai', icon: Sparkles, label: 'Asistente IA' },
    ],
  },
];

export function Sidebar() {
  const { sidebarOpen, toggleSidebar } = useAppStore();

  return (
    <aside
      className={cn(
        'fixed left-0 top-0 z-40 h-screen border-r bg-card transition-all duration-300 flex flex-col',
        sidebarOpen ? 'w-64' : 'w-16'
      )}
    >
      {/* Logo */}
      <div className="flex h-16 items-center justify-between border-b px-4">
        {sidebarOpen && (
          <span className="text-xl font-bold bg-gradient-to-r from-primary to-purple-400 bg-clip-text text-transparent">
            Teresita
          </span>
        )}
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleSidebar}
          className="ml-auto"
        >
          {sidebarOpen ? <ChevronLeft size={18} /> : <ChevronRight size={18} />}
        </Button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto px-2 py-4">
        {navItems.map((section) => (
          <div key={section.section} className="mb-6">
            {sidebarOpen && (
              <span className="mb-2 block px-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                {section.section}
              </span>
            )}
            <ul className="space-y-1">
              {section.items.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.to === '/personal' || item.to === '/clientes'}
                    className={({ isActive }) =>
                      cn(
                        'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-all hover:bg-accent',
                        isActive
                          ? 'bg-primary/10 text-primary'
                          : 'text-muted-foreground hover:text-foreground',
                        !sidebarOpen && 'justify-center px-2'
                      )
                    }
                  >
                    <item.icon size={20} />
                    {sidebarOpen && <span>{item.label}</span>}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

      {/* Footer */}
      {sidebarOpen && (
        <div className="border-t p-4">
          <p className="text-xs text-muted-foreground text-center">
            v1.0 — Hecho con 💜
          </p>
        </div>
      )}
    </aside>
  );
}
